const Button = ({ children }) => {
    return (
        <div className="inline-flex items-center rounded border border-transparent bg-indigo-500 px-10 py-1.5 font-medium text-white hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">{children}</div>
    )
}
export default Button